import type { z } from "@/zod";
import {
  contestAgreementRead,
  contestAgreementFile,
  contestAgreementDetail,
  contestAgreementFileType,
} from "@/schemas/contestAgreement";

export type ContestAgreementRead = z.infer<typeof contestAgreementRead>;
export type ContestAgreementDetail = z.infer<typeof contestAgreementDetail>;
export type ContestAgreementFile = z.infer<typeof contestAgreementFile>;
export type ContestAgreementFileType = z.infer<typeof contestAgreementFileType>;

export const FILE_TYPE_ORDER: ContestAgreementFileType[] = [
  "agreement",
  "contest_presentation",
  "presentation",
];
